import Hash from 'object-hash';
import { reset } from 'redux-form';
import { API } from 'aws-amplify';
import { columns, worktags } from '../components/Common/enum';
import { makeAllObjectValesAString } from '../util/util';

import {
    CREATE_RULE,
    REVERT_RULE,
    CREATE_RULE_SUBMITTING,
    CLEAR_ERROR_ON_RULE_CREATION,
    ERROR_ON_RULE_CREATION,
    DELETE_RULE,
    RULE_DELETING,
    FETCH_COLUMNS,
    FETCH_RULES,
    UPDATE_RULES_WORKTAG,
    INVALID_WORKTAGS,
    INVOKE_WORKTAGS_API,
    ERROR_ON_INVOKE_WORKTAGS_API,
    RULES_API_NAME,
    ERROR_ON_SCAN,
    MERGE_RULES,
    INACTIVE_RULES_STATUS,
    STATUSES
} from './index';

const WORKTAGS = worktags;

let workTagsValidator = (worktags) => {
    let initParams = {
        response: true,
        body: {
            worktags
        }
    };
    let path = '/validateworktags';

    console.log("Init params", initParams);
    return API.post(RULES_API_NAME, path, initParams);
};

export function fetchColumns() {
    return {
        type: FETCH_COLUMNS,
        payload: columns.filter(column => {
            return column.isVisible
        })
    }
}

export function receivedAllRules(rules, options = {}) {
    if(options.inactiveOnly) {
        return {
            type: MERGE_RULES,
            payload: rules
        }
    }
    return {
        type: FETCH_RULES,
        payload: rules
    }
}

export function setInactiveRulesStatus(status) {
    return {
        type: INACTIVE_RULES_STATUS,
        payload: status
    }
}

export function fetchRules(options = { inactiveOnly: false }) {
    const inactiveOnly = options.inactiveOnly
    let initParams = {
        response: true
    };
    let path = '/scan';
    if(inactiveOnly) {
        path += `?inactiveOnly=true`
    }

    return async (dispatch) => {
        if(!inactiveOnly) {
            dispatch(receivedAllRules(null));
        } else {
            dispatch(setInactiveRulesStatus(STATUSES.LOADING))
        }
        try {
            const response = await API.get(RULES_API_NAME, path, initParams);
            if (response.data) {
                dispatch(receivedAllRules(response.data, {
                    inactiveOnly
                }));
            } else {
                console.log('No rules found.');
            }
            dispatch(setInactiveRulesStatus(STATUSES.SUCCESS))
        } catch (e) {
            if(!inactiveOnly) {
                dispatch(errorOnScan(e));
            } else {
                dispatch(setInactiveRulesStatus(STATUSES.ERROR))
            }
            console.log('Error fetching rules', JSON.stringify(e));
        } 
    }
}

export function errorOnValidateWorkTag(error) {
    return {
        type: ERROR_ON_INVOKE_WORKTAGS_API,
        payload: error
    }
}

export function errorOnScan(error) {
    return {
        type: ERROR_ON_SCAN,
        payload: error
    }
}

export function recievedInvalidWorkTags(worktags) {
    return {
        type: INVALID_WORKTAGS,
        payload: worktags
    }
}
export function invokingToGetInvalidWorkTags(worktags) {
    return {
        type: INVOKE_WORKTAGS_API,
        payload: worktags
    }
}

export function receivedUpdatedRules(updatedRules) {
    return {
        type: UPDATE_RULES_WORKTAG,
        payload: updatedRules
    }
}

export function updateRules(updatedRules) {

    return (dispatch) => {
        dispatch(recievedInvalidWorkTags(false));
        dispatch(ruleIsSubmitting(true));
        /*
        Just pick the first rule's workTags that changed since it will be representative of all the changes for all the rules.
        Making the assumption that all the other rules have valid workTags outside of the selected updated rule.
        */
        let workTags = { ...makeAllObjectValesAString(updatedRules[0].worktags) };
        for (let key in workTags) {
            if (!workTags[key]) {
                delete workTags[key];
            }
        }
        dispatch(receivedUpdatedRules(updatedRules));
        console.log("WorkTags to be Validated", workTags);
        workTagsValidator(workTags)
            .then(response => {
                console.log("Got following worktags as invalid", response.data);
                console.log("Response", response);
                if (response.data.error && Object.keys(response.data.error).length) {
                    throw new Error("There was an error in the response")
                }
                if (Object.keys(response.data).length) {
                    dispatch(recievedInvalidWorkTags(response.data));
                    for (let rule of updatedRules) {
                        for (let key of Object.keys(response.data)) {
                            if (Object.values(WORKTAGS).indexOf(key) !== -1) {
                                rule.worktags[key] = null;
                            }
                        }
                    }
                    dispatch(receivedUpdatedRules(updatedRules));

                } else {
                    let initParams = {
                        response: true,
                        body: { updatedRules }
                    };
                    let path = '/update';

                    console.log("UPDATED RULES", updatedRules)
                    let updatePromise = API.post(RULES_API_NAME, path, initParams);
                    updatePromise
                        .then(response => {
                            console.log("rule update", response);
                        })
                        .catch(error => {
                            console.log("error during rule update", error);
                            //This should fail big because the user won't be able tell something went wrong with the save.
                            //also we should deal with this error better
                            //alert('Apologies there was an error during rule update. Should this continue please contact technical support. The page will now refresh.');
                            window.location.reload();
                        })
                        .finally(() => {
                            dispatch(ruleIsSubmitting(false));
                        });
                }
            })
            .catch(error => {
                console.log("error during worktag validation", error);
                errorOnValidateWorkTag(error);
                //alert('Apologies there was an error during worktag validation. Should this continue please contact technical support.');
            })
            .finally(() => {
                dispatch(ruleIsSubmitting(false));
            });
    };
}

export function receivedCreateRule(createdRule) {
    return {
        type: CREATE_RULE,
        payload: createdRule
    };
}

export function revertRule(revertedRule) {
    return {
        type: REVERT_RULE,
        payload: revertedRule
    };
}

export function errorOnCreateRule(error) {
    console.log("errorOnCreateRule action fired");
    return {
        type: ERROR_ON_RULE_CREATION,
        payload: error
    }
}

export function clearErrorOnCreateRule() {
    return {
        type: CLEAR_ERROR_ON_RULE_CREATION
    }
}

export function ruleIsSubmitting(isSubmitting) {
    return {
        type: CREATE_RULE_SUBMITTING,
        payload: isSubmitting
    }
}

export function updateKeyRule(ruleToCreate, ruleToDelete) {
    console.log("ruleToCreate: ", ruleToCreate);
    console.log("ruleToDelete: ", ruleToDelete);
    return async (dispatch) => {
        dispatch(recievedInvalidWorkTags(false));
        dispatch(clearErrorOnCreateRule());
        dispatch(ruleIsSubmitting(true));

        try {
            console.log("validating worktags: ", ruleToCreate.worktags);
            let response = await workTagsValidator(ruleToCreate.worktags)

            console.log("Got following worktags as invalid", response.data);
            if (response.data.status === "Error") {
                dispatch(ruleIsSubmitting(false));
                throw new Error("There was an error in the response");
            }
            if (Object.keys(response.data).length) {
                dispatch(recievedInvalidWorkTags(response.data));
                dispatch(ruleIsSubmitting(false));
            } else {
                console.log("creating rule");
                await createARule(ruleToCreate);
                dispatch(receivedCreateRule(ruleToCreate));
                dispatch(reset('rule'));

                console.log("deleting rule");
                await deleteARule(ruleToDelete);
            }
        }
        catch (error) {
            dispatch(revertRule(ruleToCreate));
            dispatch(errorOnCreateRule(error));
            console.log("error creating and deleting a rule")
            console.log(error);
        }
        finally {
            console.log("completed rule create/delete");
            dispatch(ruleIsSubmitting(false));
        }
    }
}

let createARule = async function (createdRule) {
    let path = '/create';
    let initParams = {
        response: true,
        body: { createdRule }
    };
    let response = await API.post(RULES_API_NAME, path, initParams);

    createdRule.id = Hash({ tran_account: createdRule.tran_account, components: createdRule.components });
    // dispatch(receivedCreateRule(createdRule));
    console.log("rule created response", response);

    return createdRule;
}

export function createRule(createdRule) {

    return async (dispatch) => {
        dispatch(recievedInvalidWorkTags(false));
        dispatch(clearErrorOnCreateRule());
        dispatch(ruleIsSubmitting(true));

        /*
        Just pick the first rule's workTags that changed since it will be representative of all the changes for all the rules.
        Making the assumption that all the other rules have valid workTags outside of the selected updated rule.
        */
        let workTags = createdRule.worktags;
        console.log("WorkTags to be Validated", workTags);
        try {
            let response = await workTagsValidator(workTags)

            console.log("Got following worktags as invalid", response.data);
            if (response.data.status === "Error") {
                dispatch(ruleIsSubmitting(false));
                throw new Error("There was an error in the response");
            }
            if (Object.keys(response.data).length) {
                dispatch(recievedInvalidWorkTags(response.data));
                dispatch(ruleIsSubmitting(false));
            } else {
                try {
                    createdRule = await createARule(createdRule)
                    dispatch(receivedCreateRule(createdRule));
                    console.log("rule created response", response);
                    dispatch(reset('rule'));
                }
                catch (error) {
                    console.log("error during rule creation", error);
                    //This should fail big because the user won't be able tell something went wrong with the save.
                    //also we should deal with this error better
                    dispatch(revertRule(createdRule));
                    dispatch(errorOnCreateRule(error));
                }
                finally {
                    dispatch(ruleIsSubmitting(false));
                }
            }
        }
        catch (error) {
            console.log("error during worktag validation", error);
            errorOnValidateWorkTag(error);
        };
    };
}

export function receivedDeleteRule(rule) {
    return {
        type: DELETE_RULE,
        payload: rule
    }
}

export function ruleIsDeleting(isDeleting) {
    return {
        type: RULE_DELETING,
        payload: isDeleting
    }
}

export async function deleteARule(rule) {
    let path = '/delete';
    let initParams = {
        response: true,
        body: { rule }
    }

    let response = await API.del(RULES_API_NAME, path, initParams);

    console.log("rule created response", response);
}

export function deleteRule(rule) {
    return async (dispatch) => {
        dispatch(ruleIsDeleting(true));

        try {
            await deleteARule(rule);
        }
        catch (error) {
            console.log("error during rule deletion", error);
        }
        finally {
            dispatch(ruleIsDeleting(false));
        }
    };
}




// WEBPACK FOOTER //
// ./src/actions/actions-rules.js